/// <reference path="../../typings/index.d.ts" />

import {GridPlanner}  from './GridPlanner';
import {Popup} from './Popup';
//import {Center} from '../Center';

var dataArray = null;

declare var EventBus: any;

window["initPlaner"] = (prosess, title) => {
    new MainGrid("/Data/SelskapAktive", prosess, title); 
};

class MainGrid {
    mainGrid: DevExpress.ui.dxDataGrid = null;

    constructor(url: string, prosess: string, title: string) {

        //EventBus.addEventListener("refresh_grid", () => {
        //    debugger;
        //    this.mainGrid.refresh();
        //});
        var divId = "Plan_" + title;
        $("#" + title).append('<div id="' + divId + '"></div>');

        $(".btnRefresh").dxButton({
            icon: "refresh",
            text: "Oppdater",
            onClick: (e) => {
                this.mainGrid.refresh();
            }
        });

        var gridOptions: DevExpress.ui.dxDataGridOptions = {
            dataSource: new DevExpress.data.CustomStore({
                load: (loadOptions) => {
                    var d = $.Deferred();
                    $.getJSON(url).done(function (data) {
                        dataArray = data;
                        d.resolve(dataArray, { totalCount: dataArray.length });
                    }).fail((data) => {
                        $(location).attr('href', '/Home/Tilgang');
                    });
                    return d.promise();
                }
            }),
            remoteOperations: false,
            rowAlternationEnabled: true,
            allowColumnResizing: true,
            columnAutoWidth: true,
            showBorders: true,
            loadPanel: {
                text: "Henter data"
            },
            columns: [
                {
                    dataField: 'beskrivelse',
                    caption: 'Selskap'
                }
            ],
            masterDetail: {
                enabled: true,
                template: GridPlanner.showPlanner
            }
        }; 

        this.mainGrid = $("#" + divId).dxDataGrid(gridOptions).dxDataGrid("instance");
    }
}





// WEBPACK FOOTER //
// ./TS/Plan/Grid.ts